import React from 'react';
import type { SocialName } from '../../types/content';
interface SocialIconProps {
  name: SocialName;
  className?: string;
}
export function SocialIcon({
  name,
  className = 'h-5 w-5'
}: SocialIconProps) {
  if (name === 'instagram') {
    return <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true" data-id="element-444" data-mp="2zuv330gnt27e">
        <rect x="3" y="3" width="18" height="18" rx="5" data-id="element-445" data-mp="38tgjoq2km75j" />
        <circle cx="12" cy="12" r="4" data-id="element-446" data-mp="38sx6fmnv86xu" />
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" data-id="element-447" data-mp="3dsjj9uzs7l64" />
      </svg>;
  }
  if (name === 'facebook') {
    return <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true" data-id="element-448" data-mp="3ikkuddl7r5uk">
        <path d="M13.5 22v-8.2h2.8l.4-3.3h-3.2V8.4c0-.9.3-1.6 1.6-1.6h1.7V3.9c-.3 0-1.3-.1-2.5-.1-2.5 0-4.2 1.5-4.2 4.3v2.4H7.3v3.3h2.8V22h3.4z" data-id="element-449" data-mp="3nhbag0x0q1fz" />
      </svg>;
  }
  if (name === 'youtube') {
    return <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true" data-id="element-450" data-mp="eex7hm6ulcn">
        <path fillRule="evenodd" d="M21.6 7.2a2.5 2.5 0 0 0-1.8-1.8C18.2 5 12 5 12 5s-6.2 0-7.8.4a2.5 2.5 0 0 0-1.8 1.8C2 8.8 2 12 2 12s0 3.2.4 4.8a2.5 2.5 0 0 0 1.8 1.8c1.6.4 7.8.4 7.8.4s6.2 0 7.8-.4a2.5 2.5 0 0 0 1.8-1.8c.4-1.6.4-4.8.4-4.8s0-3.2-.4-4.8zM10 15.2V8.8l5.3 3.2-5.3 3.2z" data-id="element-451" data-mp="q9jnvd8xmsv6" />
      </svg>;
  }
  return <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true" data-id="element-452" data-mp="19wreqaj9hqq5">
      <path d="M16.6 2.5c.4 2.3 1.8 3.8 4.1 4v3.3c-1.5.1-2.9-.4-4.1-1.2v6.3c0 3.6-2.9 6.6-6.5 6.6S3.6 18.5 3.6 15c0-3.9 3.4-6.9 7.4-6.4v3.4c-1.9-.4-3.9.9-3.9 3 0 1.7 1.3 3.1 3 3.1s3.1-1.3 3.1-3.3V2.5h3.4z" data-id="element-453" data-mp="19ykc0z7ziylh" />
    </svg>;
}